export interface CurrencySettings {
  stripZeroCents?: boolean;
  roundDigits?: number;
  symbol?: string;
  abbreviate?: boolean;
  customAbbrSettings?: CustomAbbreviationSettings;
  calendarOptions?: CalendarPriceFormatOptions;
}

export interface Abbreviation {
  divider: number;
  decimals: number;
}

export interface CustomAbbreviationSettings {
  symbol: string;
  settings: { [digits: number]: Abbreviation };
  useSymbol?: string[];
}

interface CalendarPriceFormatOptions {
  symbol?: string;
}

export const MAX_ABBR_DIGITS = 7;

export const DEFAULT_ABBR_SETTINGS: Abbreviation = {
  divider: 1000000,
  decimals: 1,
};

export const ABBR_SETTINGS: { [digits: number]: Abbreviation } = {
  5: {
    divider: 1000,
    decimals: 1,
  },
  6: {
    divider: 1000,
    decimals: 0,
  },
  7: {
    divider: 1000000,
    decimals: 2,
  },
};

const ABBR_KO_JA_SETTINGS: { [digits: number]: Abbreviation } = {
  5: {
    divider: 10000,
    decimals: 1,
  },
  6: {
    divider: 10000,
    decimals: 1,
  },
  7: {
    divider: 10000,
    decimals: 0,
  },
};

export const currencySettings: { [currencyCode: string]: CurrencySettings } = {
  // symbol: default is the 3-language code if no symbol is defined
  // roundDigits: Default is 0 (no rounding)
  EUR: {
    symbol: '€',
  },
  CNY: {},
  KRW: {
    symbol: '₩',
    roundDigits: 3,
    stripZeroCents: true,
    customAbbrSettings: {
      symbol: '만',
      settings: ABBR_KO_JA_SETTINGS,
      useSymbol: ['kr-ko'],
    },
  },
  JPY: {
    symbol: '￥',
    roundDigits: 4,
    stripZeroCents: true,
    customAbbrSettings: {
      symbol: '万',
      settings: ABBR_KO_JA_SETTINGS,
      useSymbol: ['jp-ja'],
    },
  },
  GBP: {
    symbol: '£',
  },
  USD: {
    symbol: '$',
  },
  RUB: {
    symbol: '₽',
  },
  DKK: {
    calendarOptions: {
      symbol: ',-',
    },
  },
  NOK: {
    calendarOptions: {
      symbol: ',-',
    },
  },
  SEK: {
    calendarOptions: {
      symbol: ':-',
    },
  },
};
